<template>
  <div
    class="wrapper page-login-content"
  >
    <div class="login-wrapper">
        <div class="wrapper split-content d-flex justify-content-center">
          <div class="w-100">
            <div class="d-flex min-vh-100">
              <b-col
                class="min-vh-100 text-center d-none d-md-block col-6 left-side pl-0 pr-0">
                <div class="leftside-static-wrapper">
                  <div class="leftside-static flex-column">
                    <a
                      :href="`/${$route.params.lang || ''}`"
                    >
                      <div v-if="true" class="white-logo">
                        <img :src="require('@/assets/interview-logo.png')" />
                      </div>
                    </a>
                    <secure-password-steps></secure-password-steps>
                  </div>
                </div>
              </b-col>
              <div class="w-100 d-flex align-items-center reset-right">
                <div class="close-btn" @click="goToHome()">
                  <i class="icon-close" />
                </div>
                <frm-reset-password :return-url="returnUrl" />
              </div>
            </div>
          </div>
        </div>
      </div>

    <!-- <div v-if="cookieInfoStatus"
         id="cookie-info"
    >
      {{ resource["login.CookieInfo"] }}
      <a target="_blank"
         :href="siriusUrl + '/isveren/cerez-politikasi'"
      >{{
        resource["login.CookieLink"]
      }}</a>
      <i class="icon-close"
         @click="closeCookieInfo"
      />
    </div> -->
  </div>
</template>

<script>
import apiConfigs from '@/services/configs';
import { showNotification } from '@/static/helpers';
import hrvenueService from '../../services/hrvenue.service';
// import SecurePasswordSteps from '../common/SecurePasswordSteps.vue';

export default {
  name: 'Login',

  components: {
    FrmResetPassword: () => import('./resetPassword/frmResetPassword.vue'),
    SecurePasswordSteps: () => import('../common/SecurePasswordSteps.vue'),
  },

  data() {
    return {
      cookieInfoStatus: false,
      siriusUrl: apiConfigs.kariyerUrl,
      returnUrl: this.$route.query.returnUrl,
    };
  },

  async created() {
    const isFirstLogin = !this.$route.params.uuid && this.$route.query.p;
    if (!isFirstLogin) {
      const linkValidation = await hrvenueService.forgotPasswordLinkValidation(this.$route?.params?.id, this.$route?.params?.uuid);
      if (!linkValidation.isValid) {
        this.$router.push({ name: 'LoginView' });
      }
    }
  },

  mounted() {
    if (sessionStorage.getItem('HrVenueLoginErrors')) {
      const arrErrors = sessionStorage.getItem('HrVenueLoginErrors').split('|');

      // eslint-disable-next-line func-names
      setTimeout(function () {
        for (let i = 0; i < arrErrors.length; i += 1) {
          if (arrErrors[i]) {
            showNotification(
              this.resource['label.Error'],
              arrErrors[i],
              'error',
            );
          }
        }
      }, 300);

      sessionStorage.removeItem('HrVenueLoginErrors');
    }
  },

  methods: {
    closeCookieInfo() {
      localStorage.setItem('CookieStatus', true);
      this.getCookieInfoStatus();
    },

    getCookieInfoStatus() {
      this.cookieInfoStatus = !localStorage.getItem('CookieStatus');
    },

    goToHome() {
      const lang = this.$route.params.lang === 'en' ? '' : this.$route.params.lang;

      this.$router.push({ name: 'HomeView', params: { lang } });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/style/starter.scss";
.reset-right {
  background: #FF8D06;

  @include media-breakpoint-down(sm) {
    background: #FFF;
    flex-direction: column;
  }
}
.close-btn {
  display: none;

  @include media-breakpoint-down(sm) {
    display:flex;
    justify-content: flex-end;
    align-items: center;
    padding: 16px;
    width: 100%;
  }

  i {
    display: none;
    font-size: 24px;

    @include media-breakpoint-down(sm) {
      display: block;
    }
  }
}
  .color-white {
    color: #fff;
  }
  #login-header-wrapper {
    position: absolute;
    top: 0;
    width: 100%;
    height: 60px !important;
    box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.12);
    z-index: 10;
    top: 0;
    background: #fff;
    @media screen and (max-height: 680px) {
      position: sticky !important;
      top: 0;
    }
  }
@media screen and (max-height: 680px) {
  #login-header-wrapper {
    position: sticky !important;
    top: 0;
  }
  .header-fix {
    margin-top: 99px !important;
  }
  .leftside-static-wrapper {
    margin-top: 12px !important;
  }
}
.logo {
  height: 24px;
  background-image: url('https://img-kariyer.mncdn.com/sirius/images/knet-logo.svg');
  background-size: cover;
  width: 120px;
}
.login-container {
  &.login-header {
    .signup-btn {
      &:hover {
        text-decoration: none;
        h5 {
          color: #fff;
        }
      }
    }
    .primary-button {
      padding: 20px 16px !important;
      h5 {
        font-size: 14px !important;
        color: purple;
      }
    }
  }
}

.left-side {
  flex-direction: column;
  justify-content: center;
  .persons-svg {
    width: 100%;
    max-width: 420px;
    margin-bottom: 55px;
  }
}
.seperator {
  width: 80%;
  height: 1px;
  background: #ecedf0;
  margin: 15px;
}
.seperator2 {
  margin: 16px auto;
  width: 100%;
  height: 1px;
  background: #ecedf0;
}
.btn {
  color: purple;

  &:hover {
    background: #FF8D06;
    color: white;
  }
}

.page-login-content {
  #chat-widget-container {
    display: none;
  }
  #cookie-info {
    position: fixed;
    bottom: 0;
    width: 100%;
    text-align: center;
    padding: 15px;
    background-color: rgba(0, 0, 0, 0.7);
    font-size: 14px;
    color: #ffffff;
    z-index: 999;
    i {
      float: right;
      cursor: pointer;
    }
    a {
      font-weight: bold;
      color: #ffffff;
      text-decoration: underline;
    }
  }
  .sign-up {
    background-color: rgba(82, 70, 97, 0.1);
  }
  .login-form {
    background: #f8f9fa;
    background-position: center !important;
    background-repeat: no-repeat !important;
    justify-content: center;
    align-items: center;
    background: white;
    @include media-breakpoint-down(sm) {
      background: white;
      justify-content: flex-start;
      align-items: flex-start;
    }

    .kariyer-logo {
      width: 225px;
      @include media-breakpoint-down(sm) {
        width: 138px;
        padding-top: 30px;
      }
      @include media-breakpoint-up(md) {
        padding-top: 30px;
      }
    }
    .login-align {
      display: flex;
      flex-direction: column;
      align-items: center;
    }
    .login-header {
      margin: 16px 0;
    }
    .login-inputs {
      max-width: 360px;
      margin-left: auto;
      margin-right: auto;
      padding: 0px 24px 24px 24px;
      @include media-breakpoint-down(md) {
        margin-top: 0px;
        padding-top: 0px;
      }
      .header-text {
        color: #353535 !important;
        padding: 0px 16px 16px 16px;
        @include media-breakpoint-up(md) {
          color: inherit !important;
        }
      }
    }
  }
  .left-logo {
    background: #f8f9fa;
    background-size: cover !important;
    background-repeat: no-repeat !important;
    background-position: center !important;
  }
}

.page-login {
  .page-login-content {
    display: block !important;
  }
}
.page-login-content {
  display: none;
}

.login-container {
  width: 1140px;
}
@media screen and (max-width: 1140px) and (min-width: 612px) {
  .login-container {
    width: 100%;
    padding: 0 40px;
  }
}
@media screen and (max-width: 612px) and (min-width: 375px) {
  .login-container {
    width: 100%;
    padding: 0 20px;
  }
}
@media screen and (max-width: 375px) {
  .login-container {
    width: 100%;
    padding: 0 16px;
  }
}

  #login-header-wrapper {
    position: absolute;
    top: 0;
    width: 100%;
    height: 60px !important;
    box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.12);
    z-index: 10;
    top: 0;
    background: #fff;
    @media screen and (max-height: 680px) {
      position: sticky !important;
      top: 0;
    }
  }
  .login-wrapper {
    background: #fff;
    height: 100%;
    .left-side {
      display: flex !important;
      @media screen and (max-width: 1140px) {
        display: none !important;
      }
    }

    .white-logo {
      position: absolute;
      margin-top: -56px;
      left: 0;
      img {
        width: 260px;
      }
    }
    .leftside-static-wrapper {
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .leftside-static {
      display: flex;
      width: 388px;
      height: 388px;
      position: relative;
      transform-style: preserve-3d;
      #outer-circle {
        background: #9c44c4;
        border-radius: 50%;
        width: 353px;
        height: 353px;
        position: absolute;
        right: 0;
        top: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        transform: translateZ(-10px);
        right: -96px;
        top: -131px;
      }
      #inner-circle {
        background: #FF8D06;
        border-radius: 50%;
        width: 67%;
        height: 67%;
      }

      .static-wrapper {
        transform-style: preserve-3d;
        width: 388px;
        height: 388px;
        .top-box-wrapper {
          padding: 62px 0px 0 0;

          .top-box {
            border-left: 2px solid #666666;
            padding-left: 32px;
            &-title {
              h1 {
                font-weight: 900 !important;
                  font-size: 32px !important;
                  line-height: 130% !important;
                  color: #4C4C4C !important;
                  margin-bottom: 32px;
                  text-align: left;
              }
            }
            &-desc {
              h2 {
                font-weight: 400 !important;
                font-size: 20px !important;
                line-height: 130% !important;
                color: #4C4C4C !important;
                max-width: 350px;
                margin: 0;
              }
            }
          }
          .bottom-wrapper {
            text-align: left;
            display: flex;
            align-items: center;
            height: 97px;
            button {
              color: $purple;
              font-size: 14px;
              padding: 9px 16px;
            }
          }
        }
      }
    }
  }
</style>
